module.exports = __webpack_public_path__ + "static/img/高企.da5ad9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/高企.jpg
// module id = 68wr
// module chunks = 1